export class NavigationItem {
  constructor(public target: string, public name: string) {
  }
}
